module.exports = __webpack_public_path__ + "img/mira_690d_list.0f9ea1b1.jpg";